import React, { FC } from 'react';
import { Text, TextProps, useTheme } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import { rem } from 'utils/fonts';

interface HintProps {
  leftArrow?: boolean;
}

const GenericDescriptionText = styled(Text)`
  border-radius: 9px;
  padding: 15px;
  position: relative;
  font-size: ${rem(13)};
  line-height: 135%;
`;

const DescriptionTextArrowTop = styled(GenericDescriptionText)`
  &:after {
    content: '';
    position: absolute;
    left: 13px;
    top: -8px;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    transform: rotate(90deg);
  }
`;

const DescriptionTextArrowLeft = styled(GenericDescriptionText)`
  &:after {
    content: '';
    position: absolute;
    left: -6px;
    top: 10px;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
  }
`;

const Hint: FC<TextProps & HintProps> = ({ children, leftArrow, ...props }) => {
  const { colors } = useTheme();
  return leftArrow ? (
    <DescriptionTextArrowLeft bg="primary.100" color="gray.900" borderRight={`6px solid ${colors.primary[100]}`} {...props}>
      {children}
    </DescriptionTextArrowLeft>
  ) : (
    <DescriptionTextArrowTop bg="primary.100" color="gray.900" borderRight={`6px solid ${colors.primary[100]}`} {...props}>
      {children}
    </DescriptionTextArrowTop>
  );
};

export default Hint;
